
import React, { useEffect, useState } from "react";
import { Form, Select, Input, Button, notification } from "antd";

import { APIConstants } from "../../Common/APIConstants";
import { useNavigate, useLocation } from "react-router-dom";
import PopupUI from "../Elements/PopupUI";
import { CONFIGURATION_GROUP_METER, CONFIGURATION_STEAM_GROUP_METER, CONFIGURATION_WATER_GROUP_METER } from "../../Common/Constants";
import { useStoreUpdaterWithAPI } from "../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";

const GroupMeterPopupContent = ({
  onClose,
  isAdd,
  setIsAdd,
  isUpdate,
  setIsUpdate,
  flowGroupList,
  selectedConverterID,
  setSelectedConverterID,
  uspList,
  calculationTypeList,
  updateRecord,
  fetchFlowGroupMeterList, 
  flowGroupMeterList,
  form


 
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();

  // const [flowGroupMeterList, setFlowGroupMeterList] = useState([]);
  const [addformData, setAddformData] = useState({});
  const [flowSubGroupList, setFlowSubGroupList] = useState([]);
  const [meterNameList, setMeterNameList] = useState([]);
  const [selectedUpdateConverterID, setSelectedUpdateConverterID] =
    useState(23);
  // const [flowGroupMeterList, setFlowGroupMeterList] = useState([]);
// console.log(updateRecord)
  const [updateformData, setUpdateFormData] = useState({
    GroupMeterDetailID: "",
    GroupID: "",
    SubGroupID: "",
    MeterID: "",
    MeterName: "",
    ConverterID: "",
    CalculationTypeID: "",
  });

  const handleNotification = (msg) => {
    notification.open({
      message: `${msg}`,
    });
  };

  const handleClear = () => {
    form.resetFields();
  };

  const handleClearUpdate = () => {
    form.resetFields();
    setUpdateFormData({
      GroupMeterDetailID: "",
      GroupID: "",
      SubGroupID: "",
      MeterID: "",
      MeterName: "",
      ConverterID: "",
      CalculationTypeID: "",
    });
  };

  useEffect(() => {
    if (isAdd) {
      form.resetFields();
    }
  }, [isAdd, form]);


  useEffect(() => {
    if (addformData?.ConverterID1) {
      setSelectedConverterID(addformData?.ConverterID1);
    }
  }, [addformData?.ConverterID1, selectedConverterID]);

  useEffect(() => {
    if (selectedUpdateConverterID) {
      setSelectedConverterID(selectedUpdateConverterID);
    }
  }, [selectedUpdateConverterID]);

  useEffect(() => {
    if (isUpdate && updateRecord) {
      console.log("updateRecord:", updateRecord); 

      const initialData = {

        GroupMeterDetailID: updateRecord.groupMeterDetailID ? Number(updateRecord.groupMeterDetailID) :"",
        GroupID: updateRecord?.groupID ? Number(updateRecord.groupID) : "",
        SubGroupID: updateRecord?.subGroupID
          ? Number(updateRecord.subGroupID)
          : "",
        MeterID: updateRecord?.meterID ? Number(updateRecord.meterID) : "",
        MeterName: updateRecord?.meterName ? updateRecord.meterName : "",
        ConverterID: updateRecord?.converterID
          ? Number(updateRecord.converterID)
          : "",
        CalculationTypeID: updateRecord?.calculationTypeID
          ? Number(updateRecord.calculationTypeID)
          : "",
      };
      setUpdateFormData(initialData);
      console.log("initialData:", initialData); 
      form.setFieldsValue(initialData); 
    }

    if (!flowSubGroupList.length) {
       makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.GET_FLOW_SUB_GROUPS_DETAILS}?GroupID=${updateRecord.groupID}`,
      }).then((res) => {
        setFlowSubGroupList(res);
        console.log(res)
      });
    }

    if (!meterNameList.length && updateRecord.converterID && selectedUpdateConverterID)  {
        makeRequest({
          type: APIConstants.GET,
          url: `${APIConstants.GET_GROUP_METER_NAME_DETAILS}?ConverterID=${updateRecord.converterID}`,
        }).then((res) => {
          setMeterNameList(res);
          console.log(res)
        });
      }
    // fetchMeterNameList()

  }, [isUpdate, updateRecord, form]);





 

  useEffect(() => {
    if (isAdd) {
      form.resetFields();
    }
  }, [isAdd, form]);




  const handleAddFormChange = (changedFields) => {
    if ("GroupID1" in changedFields) {
      const selectedGroup = flowGroupList.find(
        (group) => group.groupID === changedFields.GroupID1
      );
      // console.log(selectedGroup);

      if (selectedGroup) {
        makeRequest({
          type: APIConstants.GET,
          url: `${APIConstants.GET_FLOW_SUB_GROUPS_DETAILS}?GroupID=${selectedGroup.groupID}`,
        }).then((res) => {
          setFlowSubGroupList(res);
          // console.log(flowGroupList)
        });
      }

      form.setFieldsValue({
        SubGroupID1: undefined,
        ConverterID1: undefined,
        MeterID1: undefined,
      });
    } else if ("SubGroupID1" in changedFields) {
      form.setFieldsValue({
        ConverterID1: undefined,
        MeterID1: undefined,
      });
    } else if ("ConverterID1" in changedFields) {
      const converterID = changedFields.ConverterID1;
      console.log(converterID)

      // fetchMeterNameList()

      makeRequest({
        type: APIConstants.GET,
        url: `${APIConstants.GET_GROUP_METER_NAME_DETAILS}?ConverterID=${converterID}`,
      }).then((res) => {
        setMeterNameList(res);
        console.log(res);
      });

      form.setFieldsValue({
        MeterID1: undefined,
      });

      // setSelectedConverterID(converterID);
    }

    setAddformData({ ...addformData, ...changedFields });
  };

  
  const handleAddFormSubmit = async () => {
    const meterNameobj = meterNameList?.find(
      (item) => Number(item?.meterid) === Number(addformData?.MeterID1)
    );
    try {
      const formData = {
        GroupID: Number(addformData?.GroupID1),
        SubGroupID: Number(addformData?.SubGroupID1),
        MeterID: Number(addformData?.MeterID1),
        MeterName: meterNameobj?.metername,
        ConverterID: Number(addformData?.ConverterID1),
        CalculationTypeID: Number(addformData?.CalculationTypeID1),
      };



      const fetchDataForGroupMeter = await makeRequest({
        type: APIConstants.GET,
        url:  APIConstants.GET_FLOW_GROUP_METER_DETAILS,
      });
 console.log(fetchDataForGroupMeter)

    
      const isDuplicateAdd = fetchDataForGroupMeter.some(
        (item) => item.subGroupID === formData.SubGroupID && item.groupID === formData.GroupID

      );

     
  
      if (isDuplicateAdd) {
        notification.warning({
          message: "Warning",
          description: "Group with the same name and  module already exists.",
        });
        return; 
      }

      makeRequest({
        type: APIConstants.POST,
        url: APIConstants.INSERT_FLOW_GROUP_METER_DETAILS,
        body: formData,
      }).then((res) => {
        // console.log(res);
      });
     
      handleNotification("Successfully Saved");
      fetchFlowGroupMeterList()
      setIsAdd(false);
      handleClear();
      onClose();
    } catch (err) {
      console.log(err);
    }
  };


 


 

  const handleUpdateFormChange = (changedValue, allValues) => {
    // console.log(meterNameList)
    const meterNameobj = meterNameList?.find(
      (item) => item?.meterid === Number(allValues?.MeterID)
    );
    // console.log(meterNameobj)
    setUpdateFormData((prev) => ({
      ...prev,
      MeterName: meterNameobj?.metername,
      allValues,
    }));
    

    setSelectedUpdateConverterID(changedValue?.ConverterID);
   
  };


  const handleUpdateFormSubmit = async () => {
    try {
      const formData = {
        GroupMeterDetailID: Number(updateformData?.GroupMeterDetailID),
        GroupID:
          Number(updateformData?.allValues?.GroupID) ||
          Number(updateformData?.GroupID),
        SubGroupID:
          Number(updateformData?.allValues?.SubGroupID) ||
          Number(updateformData?.SubGroupID),
        MeterID:
          Number(updateformData?.allValues?.MeterID) ||
          Number(updateformData?.MeterID),
        MeterName:
          updateformData?.MeterName || updateformData?.allValues.MeterID,
        ConverterID:
          Number(updateformData?.allValues?.ConverterID) ||
          Number(updateformData?.ConverterID),
        CalculationTypeID:
          Number(updateformData?.allValues?.CalculationTypeID) ||
          Number(updateformData?.CalculationTypeID),
      };
  
      makeRequest({
        type: APIConstants.PUT,
        url: APIConstants.UPDATE_FLOW_GROUP_METER_DETAILS,
        body: formData,
      }).then((res) => {
        console.log(res);
        fetchFlowGroupMeterList(); // Fetch updated data
        onClose(); // Close the popup
        handleNotification("Successfully Updated");
        handleClearUpdate(); // Clear the form
      }).catch((err) => {
        console.log(err);
      });
    } catch (err) {
      console.log(err);
    }
  };
  

  const modeselect = useSelector((state) => state.darkMode);

  const { isdarkMode } = modeselect;

  return (
    <>
      {isAdd ? (
        <Form
          form={form}
          onFinish={handleAddFormSubmit}
          name="plant-add-form"
          className="font-bold w-[350px]"
          labelCol={{ span: 10 }}
          layout="horizontal"
          onValuesChange={handleAddFormChange}
        >
          <Form.Item
            label="Group Name"
            name="GroupID1"
            rules={[{ required: true, message: "Please select group name" }]}
          >
            <Select 
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {flowGroupList?.map((item) => (
                <Select.Option
                  key={item?.groupID}
                  value={item?.groupID}
                >
                  {item?.groupName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="SubGroup Name"
            name="SubGroupID1"
            rules={[
              { required: true, message: "Please select sub group name" },
            ]}
          >
            <Select 
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {flowSubGroupList?.map((item) => (
                <Select.Option
                  key={item?.subGroupID}
                  value={item?.subGroupID}
                >
                  {item?.subGroupName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Converter Name"
            name="ConverterID1"
            rules={[
              { required: true, message: "Please select converter name" },
            ]}
          >
            <Select 
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {uspList?.map((item) => (
                <Select.Option
                  key={item?.sitE_ID}
                  value={item?.sitE_ID}
                >
                  {item.sitename}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Meter Name"
            name="MeterID1"
            rules={[
              { required: true, message: "Please select calculation type" },
            ]}
          >
            <Select
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
             dropdownClassName={isdarkMode ? 'select-dropdown-backgroundselect-dropdown-background-group' : 'light-mode-dropdown'}>
              {meterNameList?.map((item) => (
                <Select.Option
                  key={item?.meterid}
                  value={item?.meterid}
                > 
                  {item?.metername}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="CalculationTypeID"
            name="CalculationTypeID1"
            rules={[
              { required: true, message: "Please select calculation type" },
            ]}
          >
            <Select 
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'}  `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {calculationTypeList?.map((item) => (
                <Select.Option
                  key={Number(item.calculationTypeID)}
                  value={Number(item.calculationTypeID)}
                >
                  {item.calculationTypeName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item className="flex justify-end ">
            <Button
              htmlType="submit"
              className="blue-btn mr-2"
            >
              Save
            </Button>
            <Button
              className="blue-btn"
              onClick={handleClear}
            >
              Clear
            </Button>
          </Form.Item>
        </Form>
      ) : (
        <Form
          form={form}
          onFinish={handleUpdateFormSubmit}
          name="plant-add-form"
          className="font-bold w-[350px]"
          labelCol={{ span: 10 }}
          layout="horizontal"
          onValuesChange={handleUpdateFormChange}
          initialValues={updateformData}
        >
          <Form.Item
            label="Group Name"
            name="GroupID"
            rules={[{ required: true, message: "Please select group name" }]}
          >
            <Select className={isdarkMode ? 'select-dropdown-background  ' : 'light-mode-dropdown'} disabled>
              {flowGroupList?.map((item) => (
                <Select.Option
                  key={item?.groupID}
                  value={item?.groupID}
                >
                  {item?.groupName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="SubGroup Name"
            name="SubGroupID"
            rules={[
              { required: true, message: "Please select sub group name" },
            ]}
          >
            <Select  className={isdarkMode ? 'select-dropdown-background  ' : 'light-mode-dropdown'} disabled>
              {flowSubGroupList?.map((item) => (
                <Select.Option
                  key={item?.subGroupID}
                  z
                  value={item?.subGroupID}
                >
                  {item?.subGroupName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Converter Name"
            name="ConverterID"
            rules={[
              { required: true, message: "Please select converter name" },
            ]}
          >
            <Select
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {uspList?.map((item) => (
                <Select.Option
                  key={item?.sitE_ID}
                  value={item?.sitE_ID}
                >
                  {item?.sitename}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Meter Name"
            name="MeterID"
            rules={[{ required: true, message: "Please select meter name" }]}
          >
            <Select
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {meterNameList?.map((item) => (
                <Select.Option
                  key={item?.meterid}
                  value={item?.meterid}
                >
                  {item?.metername}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="CalculationType"
            name="CalculationTypeID"
            rules={[
              { required: true, message: "Please select calculation type" },
            ]}
          >
            <Select 
             className={`  ${isdarkMode ? 'custom-select-dark select-dropdown-background' : 'custom-select-light'} w-80 `}
            dropdownClassName={isdarkMode ? 'select-dropdown-background select-dropdown-background-group' : 'light-mode-dropdown'}>
              {calculationTypeList?.map((item) => (
                <Select.Option
                  key={Number(item?.calculationTypeID)}
                  value={Number(item?.calculationTypeID)}
                >
                  {item?.calculationTypeName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item className="flex justify-end ">
            <Button
              onClick={handleUpdateFormSubmit}
              // htmlType="submit"
              className="blue-btn mr-2"
            >
              Save
            </Button>
            <Button
              className="blue-btn"
              onClick={handleClear}
            >
              Clear
            </Button>
          </Form.Item>
        </Form>
      )}
    </>
  );
};

const GroupMeterPopup = ({
  isAdd,
  setIsAdd,
  isUpdate,
  setIsUpdate,
  flowGroupList,
  selectedConverterID,
  setSelectedConverterID,
  uspList,
  calculationTypeList,
  updateRecord,
  fetchFlowGroupMeterList,
  flowGroupMeterList,
  title,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm()

  const handlePopupState = (path) => {
    if (path.includes(`${CONFIGURATION_GROUP_METER}/group-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
      form.resetFields();
    } else if(path.includes(`${CONFIGURATION_STEAM_GROUP_METER}/group-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
      form.resetFields();
    }  else if(path.includes(`${CONFIGURATION_WATER_GROUP_METER}/group-add-popup`)) {
      setIsAdd(true);
      setIsUpdate(false);
      form.resetFields();
    } else if (path.includes(`${CONFIGURATION_GROUP_METER}/group-update-popup`)) {
      setIsUpdate(true);
      setIsAdd(false);
    } else if(path.includes(`${CONFIGURATION_STEAM_GROUP_METER}/group-update-popup`)){
      setIsAdd(false);
      setIsUpdate(false);
    } else if(path.includes(`${CONFIGURATION_WATER_GROUP_METER}/group-update-popup`)){
      setIsAdd(false);
      setIsUpdate(false);
    } 
  };


  useEffect(() => {
    handlePopupState(location.pathname);
    console.log(location.pathname)
  }, [location.pathname, form]);


  const handleClose = () => {
    setIsAdd(false);
    setIsUpdate(false);

    // Get the current path
    const currentPath = location.pathname;

    // Determine the base path based on the current path
    if (currentPath.includes(`${CONFIGURATION_GROUP_METER}/group-meter-add-popup`)) {
      navigate(CONFIGURATION_GROUP_METER);
    } else if (currentPath.includes(`${CONFIGURATION_STEAM_GROUP_METER}/group-meter-add-popup`)) {
      navigate(CONFIGURATION_STEAM_GROUP_METER);
    } else if (currentPath.includes(`${CONFIGURATION_WATER_GROUP_METER}/group-meter-add-popup`)) {
      navigate(CONFIGURATION_WATER_GROUP_METER);
    }

    // Reset the form fields
    form.resetFields();
  };

  return (
    <PopupUI
      popupContent={
        <GroupMeterPopupContent
          onClose={handleClose}
          isAdd={isAdd}
          isUpdate={isUpdate}
          flowGroupList={flowGroupList}
          selectedConverterID={selectedConverterID}
          setSelectedConverterID={setSelectedConverterID}
          uspList={uspList}
          calculationTypeList={calculationTypeList}
          updateRecord={updateRecord}
          setIsAdd={setIsAdd}
          fetchFlowGroupMeterList={fetchFlowGroupMeterList}
          flowGroupMeterList={flowGroupMeterList}
          form={form}
          title={title}
        />
      }
      isAdd={isAdd}
      setIsAdd={setIsAdd}
      isUpdate={isUpdate}
      setIsUpdate={setIsUpdate}
      handleClose={handleClose}
      title={title}
    />
  );
};

export default GroupMeterPopup;


